import React, { useContext, useEffect, useState } from "react";
import AlertContext from "../Contexts/AlertContext";
import NavContext from "../Contexts/NavContext";
import AlertTypes from "../Enums/AlertTypes";
import { useNavigate } from "react-router-dom";
import AuthContext from "../Contexts/AuthContext";
import { authFileRequest, fileRequest } from "../APIs/api";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

function OrderForm() {

    const {alert, setShowAlert, openAlert, currentOrder, updateCurrentOrder} = useContext(AlertContext);
    const { isLoggedIn, loggedUser, cookies } = useContext(AuthContext);
    const {selectNav} = useContext(NavContext);

    const navigate = useNavigate();

    const [inputs, setInputs] = useState<any>({
        imei: "",
        problem: "",
        phone_image: null,
        full_name: "",
        phone: ""
    });

    useEffect(() => {

        if(!currentOrder.service || !currentOrder.device) {
            navigate("/home"); (selectNav && selectNav("device"));
        }

        if(isLoggedIn && loggedUser) {
            setInputs({...inputs, full_name: loggedUser.FullName, phone: loggedUser.Phone});
        }

    }, [])

    const submitOrder = async () => {

        let fullname_validator = /[0-9\*&<>=@'"!)(\[\])^$#|?\.,\{\}%_\-\+]/g;
        let phone_validator = /[a-zA-Z\*&<>=@'"!)(\[\])^$#|?\.,\{\}%_\-]/g;
        let problem_validator = /[\*&<>=@'"!)(\[\])^$#|?\.,\{\}%_\-\+]/g;

        try {

            if(inputs.problem == "" || inputs.full_name == "" || inputs.phone == "") {
                throw new Error("please make sure you fill the required fields!");
            }

            if(fullname_validator.test(inputs.full_name)) {
                throw new Error("Name should not contain special characters and numbers.");
            }

            if(phone_validator.test(inputs.phone)) {
                throw new Error("Phone should not contain special characters and alphabet characters.");
            }

            if(phone_validator.test(inputs.imei)) {
                throw new Error("IMEI should not contain special characters and alphabet characters.");
            }

            if(problem_validator.test(inputs.problem)) {
                throw new Error("Problem should not contain special characters.");
            }

            updateCurrentOrder({...currentOrder, form: inputs});
            navigate("/confirm_order");
            // selectNav && selectNav("home");

        } catch(error: any) {
            openAlert(AlertTypes.Error, error.message); 
        }

    }

    const inputChange = (event: any) => {
        setInputs((npt: any) => ({...npt, [event.target.name]: (event.target.name == "phone_image" ? event.target.files[0] : event.target.value)}))
    }

    return (currentOrder.service && currentOrder.device) && (
        <div className="w-100 nuwa_group px-3">
            <h4 className="card-title">{currentOrder.service.title}</h4>
            <p className="card-subtitle">
                fill the form accordingly. not that there are required and optional field so make sure you fill all the required fields.
            </p>
            <hr className="nuwa-line-hr" />
            <span className="card-title lead"><b>IMEI Number</b></span>
            <div className="nuwa-search-container mb-3 nuwa_panel" style={{padding: "10px", paddingRight: "5px"}}>
                <input type="text" value={inputs.imei} name="imei" onChange={inputChange} className="nuwa-search-input w-100" placeholder="IMEI Number of Mobile" />
            </div>
            <span className="card-title lead"><b><span className="text-danger">*</span>Problem Explanation</b></span>
            <div className="nuwa-search-container mb-3 nuwa_panel" style={{padding: "10px", paddingRight: "5px"}}>
                <textarea value={inputs.problem} name="problem" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Explane the Problem" />
            </div>
            <span className="card-title lead"><b> Phone Image</b></span>
            <div className="nuwa-search-container mb-3 nuwa_panel" style={{padding: "10px", paddingRight: "5px"}}>
                <input type="file" name="phone_image" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Phone Image" />
            </div>

            {
                (!isLoggedIn) && (
                    <>
                        <h4 className="card-title mt-5">User Information</h4>
                        <hr className="nuwa-line-hr" />

                        <span className="card-title lead"><b><span className="text-danger">*</span> Full Name</b></span>
                        <div className="nuwa-search-container mb-3" style={{padding: "10px", paddingRight: "5px"}}>
                            <input type="text" value={inputs.full_name} name="full_name" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Customer Full Name" />
                        </div>

                        <span className="card-title lead"><b><span className="text-danger">*</span> Phone Number</b></span>
                        <div className="d-flex nuwa-search-container mb-3 nuwa_panel" style={{padding: "10px", paddingRight: "5px"}}>
                            <span className="card-subtitle me-2">+251</span>
                            <input type="text" value={inputs.phone} name="phone" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Phone Number to Contact You" />
                        </div>
                    </>
                )
            }

            <button className="nuwa-white-btn py-2 px-2 text-center w-75"
                onClick={() => {
                    submitOrder();
                }}
            >
                Order Service
            </button>
        </div>
    );
}

export default OrderForm;